import { motion } from 'framer-motion';
import { projects } from '../../../data/projects';
import ProjectCard from './ProjectCard';
import './work.scss';

export default function Work() {
  return (
    <section className="work" id="work">
      <div className="work__header">
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="work__eyebrow"
        >
          Selected Work
        </motion.div>
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: [0.25, 1, 0.5, 1] }}
          className="work__title"
        >
          What I've built.
        </motion.h2>
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2, duration: 0.8 }}
          className="work__subtitle"
        >
          Selected projects across iOS and the web — built solo and with teams.
        </motion.p>
      </div>
      <div className="work__grid">
        {projects.map((p, i) => (
          <ProjectCard key={p.id} project={p} index={i} />
        ))}
      </div>
    </section>
  );
}
